import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/auth';
import Button from '../components/Button';
import Card from '../components/Card';
import './Auth.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);

    try {
      const result = await forgotPassword(email);
      
      if (result.success) {
        setSuccess(result.message || 'Password reset code sent to your email. Please check your inbox.');
        setEmail('');
      } else {
        setError(result.message || 'Failed to send reset code');
      }
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <Card className="auth-card">
          <h1 className="auth-title">Reset Password</h1>
          <p className="auth-subtitle">Enter your email to receive a password reset code</p>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your@email.com"
                className="form-input"
              />
            </div>

            <Button 
              type="submit" 
              variant="primary" 
              disabled={loading}
              className="auth-button"
            >
              {loading ? 'Sending...' : 'Send Reset Code'}
            </Button>
          </form>

          <div className="auth-links">
            <span>Remember your password?</span>
            <Link to="/login" className="auth-link">
              Sign in
            </Link>
          </div>

          {success && (
            <div className="auth-links" style={{ marginTop: '1rem' }}>
              <Link to="/reset-password" className="auth-link">
                Enter reset code →
              </Link>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
